import {Channel, ChannelConfig} from "../model/channels.model";
import {ActivatedRoute} from "@angular/router";

export class UtilsService {

  static channelId(data: ChannelConfig): string {
    return `${data.owner}#${data.vertical}#${data.code}`;
  }

  static channelConfigRest(data: ChannelConfig): string {
    return `${data.owner}/${data.vertical}/${data.code}`;
  }

  static channelRest(data: Channel): string {
    return `${data.owner}/${data.vertical}/${data.code}`;
  }

  static getAsDate(data: number | undefined) {
    if (data) {
      return new Date(data).toLocaleString();
    } else {
      return new Date().toLocaleString();
    }
  }

  static generateRandomString(length: number = 7): string {
    const chars = "abcdefghijklmnopqrstuvwxyz";
    let result = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      result += chars[randomIndex];
    }

    return result;
  }

  static getDeepestActivatedRoute(route: ActivatedRoute, depth: number = 0, maxDepth: number = 5): ActivatedRoute {
    if (depth >= maxDepth || !route.firstChild) {
      return route;
    }
    return this.getDeepestActivatedRoute(route.firstChild, depth + 1, maxDepth);
  }

}
